define('OutSystems/ClientRuntime/modules/Database/Common/Serializer',["require", "exports", "../../../DataTypes", "../../../Exceptions", "../../../Logger", "../AutoNumber", "../DatabaseTypeUtils", "../DBDataType", "../TableInfoUtils"], function (require, exports, DataTypes_1, Exceptions_1, Logger, AutoNumber_1, DatabaseTypeUtils_1, DBDataType_1, TableInfoUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var NULLDATE_IN_DB = "1900-01-01 00:00:00";
    var MASK_4_ZEROES = "0000";
    var MASK_2_ZEROES = "00";
    var Serializer = (function () {
        function Serializer() {
            var _this = this;
            this.serializers = new Map();
            this.deserializers = new Map();
            this.serializers.set(DBDataType_1.default.BINARY_DATA, function (value, typeInfo) {
                return _this.serializeBinaryData(value, typeInfo);
            });
            this.serializers.set(DBDataType_1.default.BOOLEAN, function (value, typeInfo) { return _this.serializeBoolean(value, typeInfo); });
            this.serializers.set(DBDataType_1.default.DATE, function (value, typeInfo) { return _this.serializeDate(value, typeInfo); });
            this.serializers.set(DBDataType_1.default.DATE_TIME, function (value, typeInfo) {
                return _this.serializeDateTime(value, typeInfo);
            });
            this.serializers.set(DBDataType_1.default.DECIMAL, function (value, typeInfo) { return _this.serializeDecimal(value, typeInfo); });
            this.serializers.set(DBDataType_1.default.INTEGER, function (value, typeInfo) { return _this.serializeInteger(value, typeInfo); });
            this.serializers.set(DBDataType_1.default.LONGINTEGER, function (value, typeInfo) {
                return _this.serializeLongInteger(value, typeInfo);
            });
            this.serializers.set(DBDataType_1.default.TEXT, function (value, typeInfo) { return _this.serializeText(value, typeInfo); });
            this.serializers.set(DBDataType_1.default.TIME, function (value, typeInfo) { return _this.serializeTime(value, typeInfo); });
            this.deserializers.set(DBDataType_1.default.BINARY_DATA, function (value, typeInfo) {
                return _this.deserializeBinaryData(value, typeInfo);
            });
            this.deserializers.set(DBDataType_1.default.BOOLEAN, function (value, typeInfo) {
                return _this.deserializeBoolean(value, typeInfo);
            });
            this.deserializers.set(DBDataType_1.default.DATE, function (value, typeInfo) { return _this.deserializeDate(value, typeInfo); });
            this.deserializers.set(DBDataType_1.default.DATE_TIME, function (value, typeInfo) {
                return _this.deserializeDateTime(value, typeInfo);
            });
            this.deserializers.set(DBDataType_1.default.DECIMAL, function (value, typeInfo) {
                return _this.deserializeDecimal(value, typeInfo);
            });
            this.deserializers.set(DBDataType_1.default.INTEGER, function (value, typeInfo) {
                return _this.deserializeInteger(value, typeInfo);
            });
            this.deserializers.set(DBDataType_1.default.LONGINTEGER, function (value, typeInfo) {
                return _this.deserializeLongInteger(value, typeInfo);
            });
            this.deserializers.set(DBDataType_1.default.TEXT, function (value, typeInfo) { return _this.deserializeText(value, typeInfo); });
            this.deserializers.set(DBDataType_1.default.TIME, function (value, typeInfo) { return _this.deserializeTime(value, typeInfo); });
        }
        Object.defineProperty(Serializer, "NULLDATE_IN_DB", {
            get: function () {
                return NULLDATE_IN_DB;
            },
            enumerable: false,
            configurable: true
        });
        Serializer.maskValue = function (value, mask) {
            var maskLength = mask.length;
            var strValue = value.toString();
            return mask.substr(0, Math.max(0, maskLength - strValue.length)) + strValue;
        };
        Serializer.maskFourZeroes = function (value) {
            return Serializer.maskValue(value, MASK_4_ZEROES);
        };
        Serializer.maskTwoZeroes = function (value) {
            return Serializer.maskValue(value, MASK_2_ZEROES);
        };
        Serializer.prototype.serialize = function (value, info, autoNumber) {
            if (autoNumber === void 0) { autoNumber = AutoNumber_1.default.No; }
            if (value instanceof DataTypes_1.GenericRecord) {
                return this.serializeRecord(value, info);
            }
            else {
                return this.serializeBasicType(value, info, autoNumber);
            }
        };
        Serializer.prototype.serializeRecord = function (record, info) {
            var _this = this;
            Logger.trace(this, "Starting to serialize a record");
            var databaseRecord = {};
            record.getAttributes().forEach(function (attribute) {
                var columnInfo = TableInfoUtils.getMatchingColumn(info, attribute);
                databaseRecord[columnInfo.columnName] = _this.serializeBasicType(record[attribute.attrName], columnInfo, columnInfo.isPrimaryKey ? info.idIsAutoNumber : AutoNumber_1.default.No);
            });
            Logger.trace(this, "Finished serializing a record");
            return databaseRecord;
        };
        Serializer.prototype.serializeInteger = function (value, typeInfo) {
            return value !== null && value !== void 0 ? value : 0;
        };
        Serializer.prototype.serializeText = function (value, typeInfo) {
            return value !== null && value !== void 0 ? value : "";
        };
        Serializer.prototype.serializeBoolean = function (value, typeInfo) {
            return value ? 1 : 0;
        };
        Serializer.prototype.serializeLongInteger = function (value, typeInfo) {
            return value ? value.toString() : "0";
        };
        Serializer.prototype.serializeDecimal = function (value, typeInfo) {
            return !typeInfo.decimals ? value.toString() : value.toFixed(typeInfo.decimals);
        };
        Serializer.prototype.serializeDate = function (value, typeInfo) {
            var nativeDate = value.toNative();
            return (Serializer.maskFourZeroes(nativeDate.getFullYear()) +
                "-" +
                Serializer.maskTwoZeroes(nativeDate.getMonth() + 1) +
                "-" +
                Serializer.maskTwoZeroes(nativeDate.getDate()));
        };
        Serializer.prototype.serializeTime = function (value, typeInfo) {
            var nativeTime = value.toNative();
            return (Serializer.maskTwoZeroes(nativeTime.getHours()) +
                ":" +
                Serializer.maskTwoZeroes(nativeTime.getMinutes()) +
                ":" +
                Serializer.maskTwoZeroes(nativeTime.getSeconds()));
        };
        Serializer.prototype.serializeDateTime = function (value, typeInfo) {
            if (value.eq(DataTypes_1.DateTime.defaultValue)) {
                return NULLDATE_IN_DB;
            }
            var nativeDateTime = value.toNative();
            return (Serializer.maskFourZeroes(nativeDateTime.getUTCFullYear()) +
                "-" +
                Serializer.maskTwoZeroes(nativeDateTime.getUTCMonth() + 1) +
                "-" +
                Serializer.maskTwoZeroes(nativeDateTime.getUTCDate()) +
                " " +
                Serializer.maskTwoZeroes(nativeDateTime.getUTCHours()) +
                ":" +
                Serializer.maskTwoZeroes(nativeDateTime.getUTCMinutes()) +
                ":" +
                Serializer.maskTwoZeroes(nativeDateTime.getUTCSeconds()));
        };
        Serializer.prototype.innerSerializeBasicType = function (value, columnInfo, autoNumber) {
            return undefined;
        };
        Serializer.prototype.serializeBasicType = function (value, columnInfo, autoNumber) {
            Logger.trace(this, "Serializing a value of type " + columnInfo.type);
            if (!this.serializers.has(columnInfo.type)) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to serialize " + columnInfo.type + " to a database value.");
            }
            var innerValue = this.innerSerializeBasicType(value, columnInfo, autoNumber);
            if (innerValue !== undefined) {
                return innerValue;
            }
            var serializer = this.serializers.get(columnInfo.type);
            return serializer(value, columnInfo);
        };
        Serializer.prototype.deserialize = function (value, info, complexType) {
            if (complexType) {
                return this.deserializeRecord(value, info, complexType);
            }
            else {
                return this.deserializeBasicType(value, info);
            }
        };
        Serializer.prototype.deserializeRecord = function (record, info, complexType) {
            var _this = this;
            var result = new complexType();
            complexType.getAttributes().forEach(function (attribute) {
                var columnInfo = TableInfoUtils.getMatchingColumn(info, attribute);
                result[attribute.attrName] = _this.deserializeBasicType(record[columnInfo.columnName], columnInfo);
            });
            return result;
        };
        Serializer.prototype.deserializeInteger = function (value, typeInfo) {
            return value;
        };
        Serializer.prototype.deserializeLongInteger = function (value, typeInfo) {
            return DataTypes_1.LongInteger.fromValue(value);
        };
        Serializer.prototype.deserializeDecimal = function (value, typeInfo) {
            return new DataTypes_1.Decimal(value);
        };
        Serializer.prototype.deserializeText = function (value, typeInfo) {
            return value;
        };
        Serializer.prototype.deserializeBoolean = function (value, typeInfo) {
            return value !== 0;
        };
        Serializer.prototype.deserializeDateTime = function (value, typeInfo) {
            if (value === NULLDATE_IN_DB) {
                return DataTypes_1.DateTime.defaultValue;
            }
            var DateTimeDbParseRegExp = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
            var dtParts = DateTimeDbParseRegExp.exec(value);
            var nativeDateTime = new Date();
            nativeDateTime.setUTCFullYear(parseInt(dtParts[1], 10), parseInt(dtParts[2], 10) - 1, parseInt(dtParts[3], 10));
            nativeDateTime.setUTCHours(parseInt(dtParts[4], 10) || 0, parseInt(dtParts[5], 10) || 0, parseInt(dtParts[6], 10) || 0, 0);
            return new DataTypes_1.DateTime(nativeDateTime);
        };
        Serializer.prototype.deserializeDate = function (value, typeInfo) {
            var DateDbParseRegExp = /^(\d{4})-(\d{2})-(\d{2})$/;
            var dateParts = DateDbParseRegExp.exec(value);
            var nativeDate = new Date();
            nativeDate.setFullYear(parseInt(dateParts[1], 10), parseInt(dateParts[2], 10) - 1, parseInt(dateParts[3], 10));
            nativeDate.setHours(0, 0, 0, 0);
            return new DataTypes_1.DateTime(nativeDate);
        };
        Serializer.prototype.deserializeTime = function (value, typeInfo) {
            var TimeDbParseRegExp = /^(\d{2}):(\d{2}):(\d{2})$/;
            var TimeParts = TimeDbParseRegExp.exec(value);
            var nativeTime = new Date();
            nativeTime.setFullYear(1900, 0, 1);
            nativeTime.setHours(parseInt(TimeParts[1], 10) || 0, parseInt(TimeParts[2], 10) || 0, parseInt(TimeParts[3], 10) || 0, 0);
            return new DataTypes_1.DateTime(nativeTime);
        };
        Serializer.prototype.innerDeserializeBasicType = function (value, typeInfo) {
            return undefined;
        };
        Serializer.prototype.deserializeBasicType = function (value, typeInfo) {
            if (!this.deserializers.has(typeInfo.type)) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to deserialize " + typeInfo + " to a runtime value.");
            }
            var innerValue = this.innerDeserializeBasicType(value, typeInfo);
            if (innerValue !== undefined) {
                return innerValue;
            }
            if (value === null) {
                return DatabaseTypeUtils_1.typeDefaultValue(typeInfo.type);
            }
            var deserializer = this.deserializers.get(typeInfo.type);
            return deserializer(value, typeInfo);
        };
        return Serializer;
    }());
    exports.default = Serializer;
});
//# sourceMappingURL=Serializer.js.map;
